import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Terms = () => (
    <LegalPage product="InvoSync" title="Terms &amp; Conditions">
        <p><strong>Effective Date:</strong> March 22, 2026</p>

        <Typography variant="h6">1. Service Overview</Typography>
        <p>
            InvoSync provides invoicing and billing tools for businesses.
        </p>

        <Typography variant="h6">2. User Responsibility</Typography>
        <p>You are responsible for:</p>
        <ul>
            <li>Accuracy of invoices</li>
            <li>Compliance with tax laws</li>
        </ul>

        <Typography variant="h6">3. Payments</Typography>
        <ul>
            <li>Subscriptions handled via Apple/Google</li>
            <li>No direct payment processing stored by us</li>
        </ul>

        <Typography variant="h6">4. Data Ownership</Typography>
        <p>
            You retain full ownership of your data.
        </p>

        <Typography variant="h6">5. Acceptable Use</Typography>
        <p>
            You may not use the app for illegal financial activities.
        </p>

        <Typography variant="h6">6. Termination</Typography>
        <p>
            Accounts may be suspended for violations.
        </p>

        <Typography variant="h6">7. Liability</Typography>
        <p>
            We are not responsible for financial losses or tax issues.
        </p>

        <Typography variant="h6">8. Updates</Typography>
        <p>
            Terms may change at any time.
        </p>

        <Typography variant="h6">9. Contact</Typography>
        <p>Email: evolvedevlabs@gmail.com</p>
    </LegalPage>
);

export default Terms;
